import { render, staticRenderFns } from "./SAccountNew.vue?vue&type=template&id=5bdcee52&scoped=true"
import script from "./SAccountNew.vue?vue&type=script&lang=js"
export * from "./SAccountNew.vue?vue&type=script&lang=js"
import style0 from "./SAccountNew.vue?vue&type=style&index=0&id=5bdcee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdcee52",
  null
  
)

export default component.exports